// extracted by mini-css-extract-plugin
module.exports = {"grayframe":"styles_grayframe__3wu8A","row":"styles_row__OGiMm","publishTime":"styles_publishTime__2B0K4"};